import React from 'react';
import { CardContent, makeStyles, Box, Typography } from '@material-ui/core';
import PlusIcon from '@material-ui/icons/Add';
import i18n from 'i18n';

import styles from './styles';

const useStyles = makeStyles(styles);

const EmptyCard = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container} data-testid={'autosky-emptycard'}>
      <CardContent className={classes.content}>
        <PlusIcon />
        <Typography variant="h6" component="h4" className={classes.value}>
          {i18n.t('DO_NOT_HAVE_DASHBOARD_KEY')}
        </Typography>
      </CardContent>
    </Box>
  );
};

export default EmptyCard;
